import { palette, spaces } from '@kimuno/theme';
import { IconButton, SvgIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';

import getMuiIcon from '../../../../../utils/getMuiIcon';
import Tooltip from '../../../../Tooltip';

/** @storybook-internal Takes the send button's place while dictating; only meaningful inside AIAssistantFooter. */
const ConfirmDictationButton = ({
	onClick,
	disabled = false,
}: {
	onClick: () => void;
	disabled?: boolean;
}) => {
	const { t } = useTranslation();
	const label = t('Apply dictation');

	return (
		<Tooltip label={label} hideWithoutOverflow={false}>
			<IconButton
				type="button"
				data-testid="ai-assistant-confirm-dictation-button"
				sx={{ padding: spaces.xxs }}
				disabled={disabled}
				aria-label={label}
				onClick={onClick}
			>
				<SvgIcon
					sx={{
						width: 24,
						height: 24,
						color: disabled ? palette.action.disabled : palette.primary.main,
					}}
					viewBox="0 0 24 24"
					component={getMuiIcon('checkCircleFilled')}
					aria-hidden="true"
				/>
			</IconButton>
		</Tooltip>
	);
};

export default ConfirmDictationButton;
